import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { ImgWH } from '@pages/CommonStyle/common.style';

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

export const CustomerPage = styled.div`
  overflow: hidden;
  width: 100%;
  background: #fff;
  padding: 64px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding: 32px 0;
  }
`;

export const LogoRow = styled.div`
  display: flex;
  width: fit-content;
  animation: ${scroll} 100s linear infinite;
`;

export const LogoItem = styled.div`
  margin-right: 16px;
`;

// ✅ ImgWH 확장 버전
export const ImgWithBlend = styled(ImgWH)`
  opacity: 0.76;
  mix-blend-mode: luminosity;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    width: 100px;
    height: 50px;
  }
`;
